// Date helpers shared by the report pages.
//
// Never use date.toISOString() to build a report date: it converts the local midnight
// to UTC first, so during BST (UTC+1) "30/09/2026" becomes "2026-09-29" and the last
// day silently drops out of the report.

const pad = (n) => n.toString().padStart(2, "0");

// "d/m/Y" (flatpickr display format) -> local Date
export function parseDisplayDate(dateStr) {
  const [day, month, year] = dateStr.split("/").map(Number);
  return new Date(year, month - 1, day);
}

// Date | "YYYY-MM-DD" | "d/m/Y" -> "YYYY-MM-DD" using the local calendar day
export function toLocalISODate(value) {
  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) value = parseDisplayDate(value);
  }
  const date = value instanceof Date ? value : new Date(value);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// flatpickr v-model value ("d/m/Y to d/m/Y" string or array) -> ["YYYY-MM-DD", "YYYY-MM-DD"] or null
export function toDateRange(selectedDates) {
  let dates = selectedDates;
  if (typeof dates === "string") {
    if (!dates.includes(" to ")) return null;
    dates = dates.split(" to ");
  }
  if (!Array.isArray(dates) || dates.length !== 2) return null;
  return dates.map(toLocalISODate);
}

// Year-to-date ranges used for board reporting: Q1 = 1 Jan-31 Mar, Q2 = 1 Jan-30 Jun, ...
export function yearToQuarterEnd(quarter, year = new Date().getFullYear()) {
  return [new Date(year, 0, 1), new Date(year, quarter * 3, 0)];
}
